<template>
  <div>
    <PaymentForm
      :bulk="true"
      :forClient="true"
      :activeSub="activeSub"
      :groupRedirect="true"/>
  </div>
</template>

<script>
import PaymentForm from '../../components/Forms/PaymentForm'
import { mapGetters } from 'vuex'

export default {
  name: 'BulkPayment',
  components: { PaymentForm },
  computed: {
    ...mapGetters(['groups', 'activeGroup']),
    activeSub() {
      const group = this.groups.data.find(g => g._id === this.activeGroup)
      return group && group.stripeId
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/Pages/BulkUpload/BulkPayment.vue?286d2ed0